"use client";

import { Suspense, use } from "react";
import { useLoader, Link } from "@rangojs/router/client";
import { CartLoader } from "../loaders/cart.js";

function CartBadge({ cartUrl }: { cartUrl: string }) {
  const { data } = useLoader(CartLoader);
  const cart = use(data.cart);

  const itemCount =
    cart?.productItems?.reduce((sum: number, item: any) => sum + (item.quantity ?? 0), 0) ?? 0;

  return (
    <Link
      to={cartUrl}
      prefetch="viewport"
      className="relative text-sm font-medium text-slate-600 transition-colors hover:text-slate-900"
    >
      Cart
      {itemCount > 0 && (
        <span className="absolute -top-2 -right-4 flex h-4 min-w-4 items-center justify-center rounded-full bg-slate-900 px-1 text-[10px] font-bold text-white">
          {itemCount}
        </span>
      )}
    </Link>
  );
}

export function CartIcon({ cartUrl }: { cartUrl: string }) {
  return (
    <Suspense
      fallback={
        <Link to={cartUrl} prefetch="viewport" className="text-sm font-medium text-slate-600">
          Cart
        </Link>
      }
    >
      <CartBadge cartUrl={cartUrl} />
    </Suspense>
  );
}
